import React, { Component, Fragment } from "react";
import Close from "../../assets/close-black.png";
import { COOKIE_KEYS } from "../../constants";
import "./CookieConsent.scss";
import dictionary from "i18next";

class CookieConsent extends Component {
  constructor(props) {
    super();
    this.state = {
      askCookieConsent: false,
      consent: false,
    };
  }

  componentDidMount() {
    const currentRoute = window.location.pathname;
    let cookie = document.cookie;
    let found = cookie
      .split(";")
      .findIndex((val) => val.includes("cookieConsent"));
    if (
      found > 0 &&
      cookie
        .split(";")
        .findIndex((val) => val.includes(COOKIE_KEYS.cookieConsent)) < 0
    ) {
      this.setCookies(COOKIE_KEYS.cookieConsent, true);
      cookie = document.cookie;
      this.setCookies(COOKIE_KEYS.cookieConsent, "", {
        expires: "Thu, 01 Jan 1970 00:00:00 UTC",
      });
    }
    found = cookie
      .split(";")
      .findIndex((val) => val.includes(COOKIE_KEYS.cookieConsent));
    if (found >= 0) {
      let consent = cookie.split(";")[found];
      consent = consent.split("=");
      this.setState({ consent: consent[1] });
    }

    else if (currentRoute === "/en" || currentRoute === "/") {

      this.setState({
        askCookieConsent: false,
      });
    }

  }

  cookieAnswer = (ans) => {
    if (ans) {
      let now = new Date();
      now.setFullYear(now.getFullYear() + 1);
      this.setState({ consent: ans });
      this.setCookies("cookieConsent", ans, {
        expires: `+${now.toGMTString()}+`,
      });
    }
    this.setState({ askCookieConsent: false });
  };

  setCookies = (name, value, options = {}) => {
    options = {
      path: "/",
      ...options,
    };

    let updatedCookie = `${encodeURIComponent(name)} = ${encodeURIComponent(
      value
    )}`;

    for (let optionKey in options) {
      updatedCookie += `; ${optionKey}`;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += `= ${optionValue}`;
      }
    }

    document.cookie = updatedCookie;
  };

  render() {
    let cookieHeader =
      this.props.data &&
        this.props.data["Cookie header"] &&
        this.props.data["Cookie header"].value
        ? this.props.data["Cookie header"].value
        : "";

    let cookieDescription =
      this.props.data &&
        this.props.data["Cookie Consent Description"] &&
        this.props.data["Cookie Consent Description"].value
        ? this.props.data["Cookie Consent Description"].value
        : "";
    return (
      <Fragment>
        {this.state.askCookieConsent && (
          <div className="cookie-consent-wrapper">
            <div className="consent-block">
              <div className="close-cookie">
                <span
                  className="close_button_container"
                  onClick={() => {
                    this.cookieAnswer(false);
                  }}
                >
                  <img src={Close} alt="close" id="cookie_consent_closed" />
                </span>
              </div>
              <div className="cookie-policy-info">
                <div className="heading">{cookieHeader}</div>
                <div className="body"
                  dangerouslySetInnerHTML={{ __html: cookieDescription }}>
                </div>

              </div>
              <div
                className="jumeirah-btn jumeirah-primary-btn agree-btn"
                onClick={() => {
                  this.cookieAnswer(true);
                }}
                id="cookie_consent_agree"
              >
                {dictionary.t("CookieConsentButton", "OK,I agree")}
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default CookieConsent;
